import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { utilityRoutes } from "../../routing/routes.config";
import ApiClient from "../useApiClient";

export const useGetWebChatInformation = () => {
  const client = ApiClient();
  const location = useLocation();
  const [pointOfContactId, setPointOfContactId] = useState("");
  const [shouldRenderWebChat, setShouldRenderWebChat] = useState(false);
  const [crmId, setCrmId] = useState("");

  const disallowPages = [
    ...utilityRoutes.map((route) => route.path.toLowerCase()),
    process.env.REACT_APP_HOMEPAGE?.toLowerCase(),
  ];
  const currentLocation = location.pathname.toLowerCase();

  const shouldGetWebChatInformation = !disallowPages?.includes(currentLocation);

  useEffect(() => {
    let isCancelled = false;

    const getWebChatId = async () => {
      try {
        if (!isCancelled) {
          if (shouldGetWebChatInformation) {
            const response = await client.getWebChatContactId();
            setPointOfContactId(response.result.pointOfContactId ?? "");
            setCrmId(response.result.crmId ?? "");
            setShouldRenderWebChat(true);
          } else {
            setShouldRenderWebChat(false);
          }
        }
      } catch {
        setPointOfContactId("");
        setShouldRenderWebChat(false);
      }
    };

    getWebChatId();

    return () => {
      isCancelled = true;
    };
  }, [client, currentLocation, shouldGetWebChatInformation]);

  return { 
    pointOfContactId: pointOfContactId, 
    crmId: crmId, 
    shouldRender: shouldRenderWebChat,
  };
};

export default useGetWebChatInformation;